import React from 'react';
import { Row, Col } from 'react-bootstrap';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';
import { ReactComponent as DropdownIcon } from 'src/Images/icons/common/dropdown.svg';
import { ReactComponent as Calendar } from 'src/Images/icons/common/calendar.svg';
import getColorCode from 'src/utils/GetThemeColor';

function AdditionalDetails({
  formData,
  isEditing,
  handleOnChange,
  mobileNumberError,
  themeColor,
  unitOfMeasurementOptions,
  setUnitOfMeasurementSearchTerm,
  unitOfMeasurementLabel,
  choices,
  conditionLabel,
}) {
  return (
    <Col
      className={`theme-vertical-scrollable-container-${themeColor} vehicle-tracking-detail-height  horizontal-padding-10`}
    >
      <Row className="py-2">
        <span className="text-lg text-semi-bold">Driver Details</span>
      </Row>

      <Row>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Driver Name</span>
              </div>
              <input
                name="driverName"
                className="margin-top-5 form-input-section"
                type="text"
                value={formData.driverName || ''}
                onChange={handleOnChange}
              />
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Driver Name</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.driverName || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Mobile Number</span>
              </div>
              <input
                name="driverMobileNumber"
                className={`margin-top-5 ${
                  mobileNumberError ? 'form-input-error' : 'form-input-section'
                }`}
                type="text"
                maxLength={10}
                inputMode="numeric"
                value={formData.driverMobileNumber || ''}
                onChange={handleOnChange}
              />
              {mobileNumberError && (
                <span className="text-sm text-red">
                  Mobile number must be 10 digits
                </span>
              )}
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Mobile Number</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.driverMobileNumber || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">License Number</span>
              </div>
              <input
                name="driverLicenseNumber"
                className="margin-top-5 form-input-section"
                type="text"
                inputMode="text"
                value={formData.driverLicenseNumber || ''}
                onChange={handleOnChange}
              />
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">License Number</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.driverLicenseNumber || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">License Validity</span>
              </div>
              <div className="input-wrapper">
                <input
                  name="licenseValidity"
                  className="margin-top-5 form-input-section input-icon-date"
                  type="date"
                  value={formData.licenseValidity || ''}
                  onChange={handleOnChange}
                />
                <span className="form-input-section-icon">
                  <Calendar
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">License Validity</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.licenseValidity || '-'}
              </span>
            </div>
          )}
        </Col>
      </Row>

      <Row className="py-3 border-top mt-2">
        <span className="text-lg text-semi-bold">Document Details</span>
      </Row>

      <Row>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Remarks</span>
              </div>
              <div className="input-wrapper">
                <input
                  name="remarks"
                  className="margin-top-5 form-input-section"
                  type="text"
                  value={formData.remarks || ''}
                  onChange={handleOnChange}
                />
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Remarks</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.remarks || '-'}
              </span>
            </div>
          )}
        </Col>
      </Row>

      <Row className="py-3 border-top mt-2">
        <span className="text-lg text-semi-bold">Vehicle Details</span>
      </Row>

      <Row>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">PUC Number</span>
              </div>
              <input
                name="pucNumber"
                className="margin-top-5 form-input-section input-icon-date"
                type="text"
                value={formData.pucNumber || ''}
                onChange={handleOnChange}
              />
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">PUC Number</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.pucNumber || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">PUC Start Date</span>
              </div>
              <div className="input-wrapper">
                <input
                  name="pucStartDate"
                  className="margin-top-5 form-input-section input-icon-date"
                  type="date"
                  value={formData.pucStartDate || ''}
                  onChange={handleOnChange}
                />
                <span className="form-input-section-icon">
                  <Calendar
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">PUC Start Date</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.pucStartDate || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">PUC End Date</span>
              </div>
              <div className="input-wrapper">
                <input
                  name="pucEndDate"
                  className="margin-top-5 form-input-section input-icon-date"
                  type="date"
                  value={formData.pucEndDate || ''}
                  onChange={handleOnChange}
                />
                <span className="form-input-section-icon">
                  <Calendar
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">PUC End Date</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.pucEndDate || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Registration Certificate
                </span>
              </div>
              <input
                name="registrationCertificate"
                className="margin-top-5 form-input-section input-icon-date"
                type="text"
                value={formData.registrationCertificate || ''}
                onChange={handleOnChange}
              />
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Registration Certificate
                </span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.registrationCertificate || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Insurance Number</span>
              </div>
              <input
                name="insuranceNumber"
                className="margin-top-5 form-input-section input-icon-date"
                type="text"
                value={formData.insuranceNumber || ''}
                onChange={handleOnChange}
              />
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Insurance Number</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.insuranceNumber || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Insurance Start Date</span>
              </div>
              <div className="input-wrapper">
                <input
                  name="insuranceStartDate"
                  className="margin-top-5 form-input-section input-icon-date"
                  type="date"
                  value={formData.insuranceStartDate || ''}
                  onChange={handleOnChange}
                />
                <span className="form-input-section-icon">
                  <Calendar
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Insurance Start Date</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.insuranceStartDate || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Insurance End Date</span>
              </div>
              <div className="input-wrapper">
                <input
                  name="insuranceEndDate"
                  className="margin-top-5 form-input-section input-icon-date"
                  type="date"
                  value={formData.insuranceEndDate || ''}
                  onChange={handleOnChange}
                />
                <span className="form-input-section-icon">
                  <Calendar
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Insurance End Date</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.insuranceEndDate || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Fitness Certificate Number
                </span>
              </div>
              <input
                name="fitnessCertificateNumber"
                className="margin-top-5 form-input-section input-icon-date"
                type="text"
                value={formData.fitnessCertificateNumber || ''}
                onChange={handleOnChange}
              />
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Fitness Certificate Number
                </span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.fitnessCertificateNumber || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Fitness Certificate Start Date
                </span>
              </div>
              <div className="input-wrapper">
                <input
                  name="fitnessCertificateStartDate"
                  className="margin-top-5 form-input-section input-icon-date"
                  type="date"
                  value={formData.fitnessCertificateStartDate || ''}
                  onChange={handleOnChange}
                />
                <span className="form-input-section-icon">
                  <Calendar
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Fitness Certificate Start Date
                </span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.fitnessCertificateStartDate || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Fitness Certificate End Date
                </span>
              </div>
              <div className="input-wrapper">
                <input
                  name="fitnessCertificateEndDate"
                  className="margin-top-5 form-input-section input-icon-date"
                  type="date"
                  value={formData.fitnessCertificateEndDate || ''}
                  onChange={handleOnChange}
                />
                <span className="form-input-section-icon">
                  <Calendar
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">
                  Fitness Certificate End Date
                </span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.fitnessCertificateEndDate || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Capacity</span>
              </div>
              <input
                name="capacity"
                className="margin-top-5 form-input-section input-icon-date"
                type="number"
                value={formData.capacity || ''}
                onChange={handleOnChange}
              />
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Capacity</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.capacity || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Unit Of Measurement</span>
              </div>
              <div className="input-wrapper">
                <CustomMultiSelect
                  name="unitOfMeasurementId"
                  isMulti={false}
                  className="multi-select-input-section margin-top-5"
                  data-required-field
                  onChange={(selectedOption) => {
                    handleOnChange({
                      target: {
                        name: 'unitOfMeasurementId',
                        value: selectedOption?.value || null,
                      },
                    });
                  }}
                  onInputChange={(inputValue, { action }) => {
                    if (action === 'input-change') {
                      setUnitOfMeasurementSearchTerm(inputValue);
                    }
                  }}
                  options={unitOfMeasurementOptions}
                  classNamePrefix="react-select"
                  placeholder="Select Unit"
                  value={unitOfMeasurementOptions.find(
                    (option) => option.value === formData.unitOfMeasurementId,
                  )}
                />
                <span className="form-input-section-icon">
                  <DropdownIcon
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Unit Of Measurement</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {unitOfMeasurementLabel || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Tank Condition</span>
              </div>
              <div className="input-wrapper">
                <select
                  name="tankCondition"
                  onChange={handleOnChange}
                  className="margin-top-5 form-input-section input-icon-remove"
                  value={formData.tankCondition || ''}
                >
                  <option value="">Select a value</option>
                  {choices.map((choice) => (
                    <option key={choice.id} value={choice.id}>
                      {choice.name}
                    </option>
                  ))}
                </select>
                <span className="form-input-section-icon">
                  <DropdownIcon
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Tank Condition</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {conditionLabel(formData?.tankCondition) || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Information Panel</span>
              </div>
              <div className="input-wrapper">
                <select
                  name="informationPanel"
                  onChange={handleOnChange}
                  className="margin-top-5 form-input-section input-icon-remove"
                  value={formData.informationPanel || ''}
                >
                  <option value="">Select a value</option>
                  {choices.map((choice) => (
                    <option key={choice.id} value={choice.id}>
                      {choice.name}
                    </option>
                  ))}
                </select>
                <span className="form-input-section-icon">
                  <DropdownIcon
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Information Panel</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {conditionLabel(formData?.informationPanel) || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Lid Condition</span>
              </div>
              <div className="input-wrapper">
                <select
                  name="lidCondition"
                  onChange={handleOnChange}
                  className="margin-top-5 form-input-section input-icon-remove"
                  value={formData.lidCondition || ''}
                >
                  <option value="">Select a value</option>
                  {choices.map((choice) => (
                    <option key={choice.id} value={choice.id}>
                      {choice.name}
                    </option>
                  ))}
                </select>
                <span className="form-input-section-icon">
                  <DropdownIcon
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Lid Condition</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {conditionLabel(formData?.lidCondition) || '-'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} md={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Tyre Condition</span>
              </div>
              <div className="input-wrapper">
                <select
                  name="tyreCondition"
                  onChange={handleOnChange}
                  className="margin-top-5 form-input-section input-icon-remove"
                  value={formData.tyreCondition || ''}
                >
                  <option value="">Select a value</option>
                  {choices.map((choice) => (
                    <option key={choice.id} value={choice.id}>
                      {choice.name}
                    </option>
                  ))}
                </select>
                <span className="form-input-section-icon">
                  <DropdownIcon
                    className="icon-size-sm"
                    color={getColorCode(themeColor)}
                  />
                </span>
              </div>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Tyre Condition</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {conditionLabel(formData?.tyreCondition) || '-'}
              </span>
            </div>
          )}
        </Col>
      </Row>

      <Row className="py-3 border-top mt-2">
        <span className="text-lg text-semi-bold">Requirements</span>
      </Row>

      <Row className="padding-top-10">
        <Col xxl={3} xl={3} lg={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-row cg-5">
              <input
                name="tremCard"
                type="checkbox"
                onChange={handleOnChange}
                checked={formData.tremCard || false}
              />
              <span className="text-sm text-bold">TREM Card</span>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">TREM Card</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.tremCard ? 'Yes' : 'No'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-row cg-5">
              <input
                name="reflectors"
                type="checkbox"
                onChange={handleOnChange}
                checked={formData.reflectors || false}
              />
              <span className="text-sm text-bold">Reflectors</span>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Reflectors</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.reflectors ? 'Yes' : 'No'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-row cg-5">
              <input
                name="safetyHelmet"
                type="checkbox"
                onChange={handleOnChange}
                checked={formData.safetyHelmet || false}
              />
              <span className="text-sm text-bold">Safety Helmet</span>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Safety Helmet</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.safetyHelmet ? 'Yes' : 'No'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-row cg-5">
              <input
                name="safetyShoes"
                type="checkbox"
                onChange={handleOnChange}
                checked={formData.safetyShoes || false}
              />
              <span className="text-sm text-bold">Safety Shoes</span>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Safety Shoes</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.safetyShoes ? 'Yes' : 'No'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-row cg-5">
              <input
                name="safetyHandgloves"
                type="checkbox"
                onChange={handleOnChange}
                checked={formData.safetyHandgloves || false}
              />
              <span className="text-sm text-bold">Safety Handgloves</span>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Safety Handgloves</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.safetyHandgloves ? 'Yes' : 'No'}
              </span>
            </div>
          )}
        </Col>
        <Col xxl={3} xl={3} lg={3} className="form-input-container">
          {isEditing ? (
            <div className="div-flex-row cg-5">
              <input
                name="safetyGoggles"
                type="checkbox"
                onChange={handleOnChange}
                checked={formData.safetyGoggles || false}
              />
              <span className="text-sm text-bold">Safety Goggles</span>
            </div>
          ) : (
            <div className="div-flex-column">
              <div className="div-flex-row">
                <span className="text-sm text-bold">Safety Goggles</span>
              </div>
              <span className="text-sm text-grey margin-top-5">
                {formData?.safetyGoggles ? 'Yes' : 'No'}
              </span>
            </div>
          )}
        </Col>
      </Row>
    </Col>
  );
}

export default AdditionalDetails;
